export const containsHTML = (str) => /<[a-z][\s\S]*>/i.test(str);

export const statesCodes = (state) => {
    const codes = {
        "Aguascalientes": "AS",
        "Baja California": "BC",
        "Baja California Sur": "BS",
        "Campeche": "CC",
        "Chiapas": "CS",
        "Chihuahua": "CH",
        "Coahuila": "CL",
        "Colima": "CM",
        "Distrito Federal": "DF",
        "Durango": "DG",
        "Guanajuato": "GT",
        "Guerrero": "GR",
        "Hidalgo": "HG",
        "Jalisco": "JC",
        "México": "MC",
        "Michoacan": "MN",
        "Morelos": "MS",
        "Nayarit": "NT",
        "Nuevo León": "NL",
        "Oaxaca": "OC",
        "Puebla": "PL",
        "Querétaro": "QT",
        "Quintana Roo": "QR",
        "San Luis Potosí": "SP",
        "Sinaloa": "SL",
        "Sonora": "SR",
        "Tabasco": "TC",
        "Tlaxcala": "TL",
        "Tamaulipas": "TS",
        "Veracruz": "VZ",
        "Yucatán": "YN",
        "Zacatecas": "ZS"
    };

    return codes[state];
};

export const statesCodesById = (state) => {
    const codes = [
        "", // Desconocido
        "AS", // Aguascalientes
        "BC", // Baja California
        "BS", // Baja California Sur
        "CC", // Campeche
        "CL", // Coahuila
        "CM", // Colima
        "CS", // Chiapas
        "CH", // Chihuahua
        "DF", // Distrito Federal
        "DG", // Durango
        "GT", // Guanajuato
        "GR", // Guerrero
        "HG", // Hidalgo
        "JC", // Jalisco
        "MC", // México
        "MN", // Michoacán
        "MS", // Morelos
        "NT", // Nayarit
        "NL", // Nuevo León
        "OC", // Oaxaca
        "PL", // Puebla
        "QT", // Querétaro
        "QR", // Quintana Roo
        "SP", // San Luis Potosí
        "SL", // Sinaloa
        "SR", // Sonora
        "TC", // Tabasco
        "TS", // Tamaulipas
        "TL", // Tlaxcala
        "VZ", // Veracruz
        "YN", // Yucatán
        "ZS"  // Zacatecas
      ]

    return codes[state];
};